<template>
  <div>
    <Widget>
      <div  class="table-responsive">
        <table class="table">
          <tbody>
          <tr>
            <th colspan="2" style="text-align: center;">
              Patient Information
            </th>
          </tr>
          <tr >
            <td colspan="2" style="text-align: center;" ><img :src="getPatientImageFullUrl" height="150" width="150" alt="patient image"></td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{{ checkupPatient.name }}</td>
          </tr>
          <tr>
            <th>Gender</th>
            <td>{{ (checkupPatient.gender === 0) ? 'male' : 'female' }}</td>
          </tr>
          <tr>
            <th>Age</th>
            <td>{{ checkupPatient.age }}</td>
          </tr>
          <tr>
            <th>Weight</th>
            <td>{{ checkupPatient.weight }}</td>
          </tr>
          <tr>
            <th>Height</th>
            <td>{{ checkupPatient.height }}</td>
          </tr>
          <tr>
            <th>Blood Group</th>
            <td>{{ checkupPatient.blood_group }}</td>
          </tr>
          <tr>
            <th>Blood Pressure</th>
            <td>{{ checkupPatient.blood_pressure }}</td>
          </tr>
          <tr>
            <th>Cholesterol Level</th>
            <td>{{ checkupPatient.cholesterol_level }}</td>
          </tr>
          </tbody>
        </table>

      </div >
    </Widget>
<!--    <Widget>-->
<!--      <table class="table">-->
<!--        <tbody>-->
<!--        <tr v-for="(patientprescription, index) in checkupPatient.patientprescriptions" :key="patientprescription.id">-->
<!--          <th>Prescription {{ index + 1 }}</th>-->
<!--          <td>{{ patientprescription.code }}</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </Widget>-->
  </div>
</template>

<script>
export default {
  name: "PatientInfo",
  props: ['patient'],
  data() {
    return {
      checkupPatient: this.patient,
    };
  },
  computed: {
    getPatientImageFullUrl() {
      return process.env.VUE_APP_BACKEND_URL + '/' + this.checkupPatient.image;
    }
  },
  methods: {},
  mounted() {
    console.log(this.patient);
  }
}
</script>

<style scoped>

</style>
